import { Navigate } from "react-router-dom";
import { useAdminAuth } from "@/lib/admin-auth";
import { api } from "@/lib/api";
import { Button } from "@/components/Button";

export function AdminLogin() {
  const { user, loading } = useAdminAuth();

  if (loading) return <div className="flex min-h-screen items-center justify-center bg-cream" />;
  if (user) return <Navigate to="/admin" replace />;

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-cream px-6 text-center">
      <span className="font-display text-2xl font-semibold text-ink">Allthingsnew</span>
      <div className="flex flex-col gap-2">
        <h1 className="font-display text-xl font-medium text-ink">Admin sign in</h1>
        <p className="text-sm text-stone-500">Access is restricted to the store owner's Google account.</p>
      </div>
      <a href={api.auth.googleLoginUrl()} className="w-full max-w-xs">
        <Button fullWidth>Sign in with Google</Button>
      </a>
    </div>
  );
}
